<template>
  <div class="page-skeleton">
    <header>
      <div id="page-skeleton-left" class="left">
        <slot name="header-left" />
      </div>
      <div id="page-skeleton-right" class="right">
        <slot name="header-right" />
      </div>
    </header>

    <section>
      <slot name="container" />
      <slot name="default" />
    </section>

    <footer>
      <div>
        <slot name="footer-left" />
      </div>
      <div>
        <slot name="footer-right" />
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    this.setElementMargin()
  },
  methods: {
    setElementMargin() {
      let left = document.getElementById('page-skeleton-left')
      let right = document.getElementById('page-skeleton-right')
      if (left && left.children && left.children.length) {
        left.children[left.children.length - 1].style.marginRight = 0
      }
      if (right && right.children && right.children.length) {
        right.children[0].style.marginLeft = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-skeleton {
  display: flex;
  font-size: 14px;
  height: 100%;
  padding: 12px;
  min-width: 1680px;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;

  header {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    .left {
      > * {
        margin-right: 15px;
      }
    }
    .right {
      > * {
        margin-left: 15px;
      }
    }
  }

  section {
    height: calc(100vh - 192px);
    margin: 12px 0;
    overflow: auto;
  }

  footer {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
